var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inline-flex p-[0.3rem] bg-[#F1F1F1] rounded-lg"},_vm._l((_vm.options),function(option){return _c('button',{key:option.value,class:[
      'px-[0.625rem] py-[0.3rem] text-sm font-medium rounded-md transition-colors border-none outline-none focus:outline-none',
      _vm.value === option.value
        ? 'bg-white shadow-sm text-gray-900'
        : 'text-gray-500 hover:text-gray-700 hover:bg-gray-200/50'
    ],on:{"click":function($event){return _vm.$emit('input', option.value)}}},[_vm._v(" "+_vm._s(option.label)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }